import { useFormikContext } from "formik";
import { FC, ReactElement } from "react";
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { WizardSummaryLayout } from '../wizard/wizard-summary-layout';

interface SummaryStepProps {
    originalSelectedRows: any[];
    alwaysSelectedAndDisabled: string[];
    onBack: (e: any) => void;
    idPath: string;
}

const SummaryStep: FC<SummaryStepProps> = ({  originalSelectedRows, alwaysSelectedAndDisabled, onBack, idPath}) => {
    const { values } = useFormikContext<any>();
    const { translate } = useLocale();
    const selectedRows = values.selectedRows || [];
    let toBeUnassignedRows = originalSelectedRows.filter((row: any) => !selectedRows.some((current: any) => current.id.toString() === row[idPath]));
    let toBeAssignedRows = selectedRows.filter((row: any) =>!originalSelectedRows.some((original: any) => original[idPath] === row.id.toString()));
    toBeAssignedRows = alwaysSelectedAndDisabled ? toBeAssignedRows.filter((row: any) => !alwaysSelectedAndDisabled.includes(row[idPath])) : toBeAssignedRows;
    toBeUnassignedRows = alwaysSelectedAndDisabled ? toBeUnassignedRows.filter((row: any) => !alwaysSelectedAndDisabled.includes(row[idPath])) : toBeUnassignedRows;

    const getItemsList = (items: any[], title: string): ReactElement => {
        if(items.length === 0) {
            return <div className="flex flex-row flex-1">
                <h4 className="p-1 text-xs text-gray-600 w-1/3">{title}</h4>
                <ul className="flex flex-col w-1/3">
                    <li className="p-1 text-sm">{translate.byKey(TranslationKeys.none)}</li>
                </ul>
            </div>
        }

        return <div className="flex flex-row flex-1">
            <h4 className="p-1 text-xs text-gray-600 w-1/3">{title}</h4>
            <ul className="flex flex-col w-1/3">
                {items.map((row: any) => (
                    <li key={row.id} className="p-1 text-sm"> {row.name} </li>
                ))}
            </ul>
        </div>
    } 

    return <WizardSummaryLayout onBack={onBack} submitLabel={translate.byKey(TranslationKeys.confirm)}>
        <div>
            {/* To Be Added */}
            {getItemsList(toBeAssignedRows, translate.byKey(TranslationKeys.toBeAssigned))}
            <hr />
            {/* To Be Removed */}
            {getItemsList(toBeUnassignedRows, translate.byKey(TranslationKeys.toBeUnassigned))}
        </div>
    </WizardSummaryLayout>
}

export default SummaryStep;